import { EnvironmentOutlined, UserOutlined } from '@ant-design/icons';
import { packageCreate } from 'global/Models/omOrderModel';
import { FC, useMemo } from 'react';
import { CgCalendarDates } from 'react-icons/cg';
import { GoPackage } from 'react-icons/go';

interface IOrderSummeryParcels {
  packages: packageCreate[];
}

const OrderSummeryParcels: FC<IOrderSummeryParcels> = ({ packages }) => {
  //constants
  const renderPacels = useMemo(
    () =>
      packages.map((pack) => (
        <div key={pack.uuid} className='flex items-stretch mb-1 overflow-hidden border rounded-lg border-t-border-color-base'>
          <div className='flex items-center justify-center px-2 border-l text-t-opposite-text-color bg-t-primary-color border-t-border-color-base color-inherit'>
            <GoPackage />
          </div>
          <div className='flex flex-col justify-between w-full gap-4 px-4 py-2 md:flex-row'>
            <div className='space-y-1'>
              <p className='flex gap-1 text-t-primary-color inherit-color'>
                <UserOutlined />
                {pack.senderClient?.fullName}
              </p>
              <p className='max-w-[30ch] line-clamp-2 text-xs'>
                <EnvironmentOutlined className='ml-1' />
                {pack.senderAddress?.address.cityTitle}/{pack.senderAddress?.address.fullAddress}
              </p>
            </div>
            <div>
              {pack.package?.map((packaging, index) => {
                const packagingTitle = packaging.packagingContentId === 1 ? 'شکستنی' : packaging?.packagingContentTitle;
                return (
                  <div key={index}>
                    <p className='flex items-center gap-2 text-t-primary-color inherit-color'>
                      <GoPackage /> {packaging?.count || 1} * {packaging?.title}
                    </p>
                    <p className='text-xs'>
                      {packagingTitle} - {packaging?.packagingTypeTitle}
                    </p>
                    <p>
                      {packaging?.width} / {packaging?.length} / {packaging?.height} - {packaging?.weight} کیلو
                    </p>
                  </div>
                );
              })}
            </div>
            <div className='space-y-1'>
              <p className='flex gap-1 text-t-primary-color inherit-color'>
                <UserOutlined />
                {pack.receiverClient?.fullName}
              </p>
              <p className='max-w-[30ch] line-clamp-2 text-xs'>
                <EnvironmentOutlined className='ml-1' />
                {pack.receiverAddress?.address.cityTitle}/{pack.receiverAddress?.address.fullAddress}
              </p>
              {pack.lockerInfo && (
                <>
                  <hr />

                  <p className=' max-w-[30ch] line-clamp-2 text-xs gap-1 inherit-color'>
                    <CgCalendarDates className='inline ' /> آدرس کیوسک:
                    {pack.lockerInfo?.locker?.kiosk.address}
                  </p>
                  <p className='text-xs'>کد پیگیری : {pack.lockerInfo?.orderNumber}</p>
                </>
              )}
            </div>
          </div>
        </div>
      )),
    [packages]
  );

  return <div>{renderPacels}</div>;
};

export default OrderSummeryParcels;
